import {
  HomeIcon,
  Cog6ToothIcon,
  MapPinIcon,
  InboxArrowDownIcon,
  ScaleIcon,
  CalendarDaysIcon,
  ArrowDownTrayIcon,
} from '@heroicons/react/24/outline';
import { TableCellsIcon } from '@heroicons/react/24/outline';
import type { ProductConfig } from '../registry';

export default {
  slug: 'datavault',
  icon: TableCellsIcon,
  accentColor: {
    bg: 'bg-cyan-500/10',
    border: 'border-cyan-500/30',
    text: 'text-cyan-400',
  },
  navigation: [
    { name: 'DATA VAULT', href: '/data-vault', icon: HomeIcon },
    { name: 'INTAKE', href: '/data-vault/intake', icon: InboxArrowDownIcon },
    { name: 'EXPORTS', href: '/data-vault/exports', icon: ArrowDownTrayIcon },
    { name: 'SAMPLING', href: '/data-vault/sampling', icon: CalendarDaysIcon },
    { name: 'REGULATORY', href: '/data-vault/settings/regulatory', icon: ScaleIcon },
    { name: 'SITES', href: '/data-vault/sites', icon: MapPinIcon },
    { name: 'SETTINGS', href: '/datavault/settings', icon: Cog6ToothIcon },
  ],
  landingPage: '/data-vault',
} satisfies ProductConfig;
